/**
 * @fileoverview Module for `src/lib/routes/ExternalRedirect.js`.
 */

interface ExternalRedirectProps {
    location:any;
  }

/**
 * Redirect helper that forwards legacy paths to the Next.js frontend.
 *
 * @param {ExternalRedirectProps} props - Route props including `location`.
 * @returns {null} Always returns null after redirecting.
 */
function ExternalRedirect(props:ExternalRedirectProps) {
  window.location.href = `${ process.env.REACT_APP_NEXT_JS_URL }${ props.location.pathname }`;
  return null;
}
export default ExternalRedirect;
